import React from "react";
import { Controller } from "react-hook-form";
import Input from "./Input";

const TextInput = ({
  name,
  control,
  displayName,
  required,
  placeholder,
  errors,
  validate,
  innerRef,
  disabled,
  className,
  onFocus,
  onSelect,
  area,
  prefix,
  maxLength,
  onChange: onValueChange,
  rows,
}) => {
  return (
    <Controller
      name={name}
      control={control}
      rules={{
        required: required ? `${displayName} is required` : null,
        validate: validate,
      }}
      render={({ field: { ref, onChange, ...field } }) => (
        <Input
          {...field}
          type={area ? "textarea" : null}
          placeholder={placeholder ?? displayName}
          invalid={!!errors}
          disabled={disabled}
          innerRef={innerRef}
          onFocus={onFocus}
          onSelect={onSelect}
          className={className}
          prefix={prefix}
          maxLength={maxLength}
          rows={rows}
          onChange={(e) => {
            onChange(e);
            if (onValueChange) onValueChange(e.target.value);
          }}
        />
      )}
    />
  );
};

export default TextInput;
